import _classCallCheck from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

// Copyright 2017-2021 @polkadot/api authors & contributors
// SPDX-License-Identifier: Apache-2.0
var recordIdentity = function recordIdentity(record) {
  return record;
};

function filterAndApply(events, section, methods, onFound) {
  return events.filter(function (_ref) {
    var event = _ref.event;
    return section === event.section && methods.includes(event.method);
  }).map(function (record) {
    return onFound(record);
  });
}

function extractError() {
  var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return filterAndApply(events, 'system', ['ExtrinsicFailed'], function (_ref2) {
    var data = _ref2.event.data;
    return data[0];
  })[0];
}

function extractInfo() {
  var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return filterAndApply(events, 'system', ['ExtrinsicFailed', 'ExtrinsicSuccess'], function (_ref3) {
    var _ref3$event = _ref3.event,
        data = _ref3$event.data,
        method = _ref3$event.method;
    return method === 'ExtrinsicSuccess' ? data[0] : data[1];
  })[0];
}

export var SubmittableResult =
/*#__PURE__*/
function () {
  function SubmittableResult(_ref4) {
    var dispatchError = _ref4.dispatchError,
        dispatchInfo = _ref4.dispatchInfo,
        events = _ref4.events,
        status = _ref4.status;

    _classCallCheck(this, SubmittableResult);

    this.dispatchError = void 0;
    this.dispatchInfo = void 0;
    this.events = void 0;
    this.status = void 0;
    this.dispatchError = dispatchError || extractError(events);
    this.dispatchInfo = dispatchInfo || extractInfo(events);
    this.events = events || [];
    this.status = status;
  }

  _createClass(SubmittableResult, [{
    key: "filterRecords",

    /**
     * @description Filters EventRecords for the specified method & section (there could be multiple)
     */
    value: function filterRecords(section, method) {
      return filterAndApply(this.events, section, Array.isArray(method) ? method : [method], recordIdentity);
    }
    /**
     * @description Finds an EventRecord for the specified method & section
     */

  }, {
    key: "findRecord",
    value: function findRecord(section, method) {
      return this.filterRecords(section, method)[0];
    }
    /**
     * @description Creates a human representation of the output
     */

  }, {
    key: "toHuman",
    value: function toHuman(isExtended) {
      var _this$dispatchError, _this$dispatchInfo;

      return {
        dispatchError: (_this$dispatchError = this.dispatchError) === null || _this$dispatchError === void 0 ? void 0 : _this$dispatchError.toHuman(),
        dispatchInfo: (_this$dispatchInfo = this.dispatchInfo) === null || _this$dispatchInfo === void 0 ? void 0 : _this$dispatchInfo.toHuman(),
        events: this.events.map(function (event) {
          return event.toHuman(isExtended);
        }),
        status: this.status.toHuman(isExtended)
      };
    }
  }, {
    key: "isCompleted",
    get: function get() {
      return this.isError || this.status.isInBlock || this.status.isFinalized;
    }
  }, {
    key: "isError",
    get: function get() {
      return this.status.isDropped || this.status.isFinalityTimeout || this.status.isInvalid || this.status.isUsurped;
    }
  }, {
    key: "isFinalized",
    get: function get() {
      return this.status.isFinalized;
    }
  }, {
    key: "isInBlock",
    get: function get() {
      return this.status.isInBlock;
    }
  }, {
    key: "isWarning",
    get: function get() {
      return this.status.isRetracted;
    }
  }]);

  return SubmittableResult;
}();